import { render, staticRenderFns } from "./SwiperFadeEffect.vue?vue&type=template&id=51672e3e&"
import script from "./SwiperFadeEffect.vue?vue&type=script&lang=js&"
export * from "./SwiperFadeEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports